import { FC } from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
    RUNTIME_CONFIGURATION_UI_VALUE_TYPES,
    RuntimeConfigurationValueType,
} from '../../../types/enums/runtime-configuration-enums';
import { getValueTypeTranslationKey, normalizeValueType } from '../runtimeConfiguration.helpers';

type Props = {
    value: RuntimeConfigurationValueType | string | number;
    readOnly?: boolean;
    onChange: (value: RuntimeConfigurationValueType) => void;
};

export const RuntimeConfigurationValueTypePicker: FC<Props> = ({ value, readOnly = false, onChange }) => {
    const { t } = useTranslation();
    const selected = normalizeValueType(value);

    return (
        <Box className="runtime-config-editor__section">
            <Typography variant="caption" className="runtime-config-editor__label">
                {t('runtimeConfiguration.fields.valueType')}
            </Typography>
            <ToggleButtonGroup
                exclusive
                size="small"
                value={selected}
                className="runtime-config-editor__segment"
                onChange={(_, next) => {
                    if (!readOnly && next) {
                        onChange(next as RuntimeConfigurationValueType);
                    }
                }}
            >
                {RUNTIME_CONFIGURATION_UI_VALUE_TYPES.map((type) => (
                    <ToggleButton
                        key={type}
                        value={type}
                        className="runtime-config-editor__segment-btn"
                        disabled={readOnly}
                    >
                        {t(getValueTypeTranslationKey(type))}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </Box>
    );
};
